var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{key:_vm.resize,staticClass:"v-bar--underline",attrs:{"id":"default-app-bar","app":"","absolute":"","color":"primary","clipped-left":_vm.$vuetify.rtl,"clipped-right":!_vm.$vuetify.rtl,"height":"60","elevation":"3"}},[_c('drawer-toggle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }